import { Box, Checkbox } from '@chakra-ui/react';
import { CloseIcon } from 'Asset/icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const HostItem = ({ host, removeHost, onUpdatePregnancy }) => {
  const { t } = useTranslation('schedule-ruleset');
  const { index, item } = host;

  const handlePregnancyChange = (isChecked) => {
    if (onUpdatePregnancy) {
      onUpdatePregnancy(index, isChecked);
    }
  };

  return (
    <Box key={index} gap={'8px'} alignItems={'center'} className={styles['host-item__container']}>
      <TextRegular>{index + 1}.</TextRegular>
      <Box className={styles['host-item__card']}>
        <TextRegular>{item?.label}</TextRegular>
        <Box className={styles['host-item__action--container']}>
          <Box className={styles['host-item__checkbox']}>
            <Checkbox isChecked={item?.isPregnancy || false} onChange={(e) => handlePregnancyChange(e.target.checked)} />
            <TextRegular onClick={() => handlePregnancyChange(!item?.isPregnancy)}>{t('labelPregnantBreastfeeding')}</TextRegular>
          </Box>
          <CloseIcon className={styles['host-item__close']} onClick={() => removeHost(index)} />
        </Box>
      </Box>
    </Box>
  );
};

export default HostItem;